import PocketBase from 'pocketbase';

declare global {
  interface Window { __ENV?: { PB_URL?: string } }
}

const runtimeUrl = window.__ENV?.PB_URL;
const envUrl = process.env.REACT_APP_PB_URL || process.env.PB_URL;

function normalizeBase(u?: string) {
  if (!u) return undefined;
  let v = u.trim();
  // strip trailing / and any trailing /api
  v = v.replace(/\/+$/, '');
  v = v.replace(/\/api$/i, '');
  return v;
}

const configured = normalizeBase(runtimeUrl || envUrl);

const isLocal =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

/**
 * Final base URL for PocketBase:
 * - Local dev → http://127.0.0.1:8090
 * - Azure (or any hosted env) → must be provided via env/runtime (configured)
 */
const baseUrl = configured || (isLocal ? 'http://127.0.0.1:8090' : undefined);

if (!baseUrl) {
  // Make missing config obvious in hosted envs
  // eslint-disable-next-line no-console
  console.error('PocketBase base URL is not configured. Set REACT_APP_PB_URL or window.__ENV.PB_URL');
}

const pb = new PocketBase(baseUrl || 'http://127.0.0.1:8090');
pb.autoCancellation(false);

// Temporary: log failed responses to see server details in Azure
// @ts-ignore
pb.afterSend = async (response: Response, data: any) => {
  if (!response.ok) {
    console.warn('[PB error]', response.status, response.url, data);
  }
  return data;
};

export default pb;